import styled from 'styled-components'

import { getSize } from 'utils'
import { theme } from 'styles/theme'
import BaseLayout from '../components/BaseLayout'
import { TextBlock, Decoration } from '../components/BaseLayout/styled'

export const StyledLayoutLight = styled(BaseLayout)`
  grid-template-areas: 'text-block illustration';
  background-color: ${theme.colors.white};

  ${TextBlock} {
    color: ${theme.colors.cloudPurple};
    font-family: 'Poppins';
    font-weight: 400;
    line-height: ${getSize(58)};
    font-size: ${getSize(48)};

    .title {
      display: inline-block;
      font-size: ${getSize(30)};
      font-weight: 800;
      line-height: ${getSize(24)};
      text-transform: uppercase;
      background-color: ${theme.colors.limeGreen};
    }

    margin-left: ${getSize(136)};

    p {
      margin-right: ${getSize(48)};
    }
  }

  @media (max-aspect-ratio: 1/1) {
    grid-template-areas:
      'illustration'
      'text-block';

    ${TextBlock} {
      margin-left: ${getSize(85)};
      margin-bottom: ${getSize(140)};
      align-self: flex-end;
    }
  }
`
export const StyledLayoutDark = styled(BaseLayout)`
  grid-template-areas: 'illustration text-block';
  background-color: ${theme.colors.cloudPurple};
  ${TextBlock} {
    margin-right: ${getSize(136)};
    color: ${theme.colors.white};
    font-family: 'Poppins';
    font-weight: 400;
    line-height: ${getSize(58)};
    font-size: ${getSize(48)};

    .title {
      display: inline-block;
      font-size: ${getSize(30)};
      font-weight: 800;
      line-height: ${getSize(24)};
      text-transform: uppercase;
      color: ${theme.colors.limeGreen};
    }

    ${Decoration} {
      margin-left: ${getSize(48)};
    }

    p {
      margin-left: ${getSize(48)};
    }
  }

  @media (max-aspect-ratio: 1/1) {
    grid-template-areas:
      'text-block'
      'illustration';

    ${TextBlock} {
      margin-top: ${getSize(140)};
      margin-right: 0;
      margin-left: ${getSize(85)};
      align-self: flex-start;

      ${Decoration} {
        margin-left: 0;
      }

      p {
        margin-left: 0;
        margin-right: ${getSize(85)};
      }
    }
  }
`
